class VideoReviewsList extends HTMLElement {
  constructor() {
    super();
    this._observer = null;
  }

  connectedCallback() {
    this._init();
    this._observeMutations();
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
  }

  _init() {
    this._cards().forEach((wrapper) => this._bindCard(wrapper));
  }

  _cards() {
    return Array.from(this.querySelectorAll(".swiper-slide .relative"));
  }

  _observeMutations() {
    if (this._observer) this._observer.disconnect();

    this._observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          this._cards().forEach((wrapper) => this._bindCard(wrapper));
        }
      }
    });

    this._observer.observe(this, {
      childList: true,
      subtree: true,
    });
  }

  _pauseAllExcept(currentVideo) {
    this.querySelectorAll("video").forEach((vid) => {
      if (vid !== currentVideo && !vid.paused) {
        vid.pause();
        vid.currentTime = 0;
      }
    });
  }

  _bindCard(wrapper) {
    if (!wrapper || wrapper.__vrBound) return;

    const v = wrapper.querySelector("video");
    const btn = wrapper.querySelector(".mi-toggle");
    if (!v) return;

    wrapper.__vrBound = true;

    const setIcon = (state) => {
      if (!btn) return;
      const svg = btn.querySelector(".mi-icon");
      if (!svg) return;
      svg.innerHTML =
        state === "pause"
          ? '<rect x="5" y="4" width="4" height="16"></rect><rect x="15" y="4" width="4" height="16"></rect>'
          : '<path d="M8 5v14l11-7-11-7z"></path>';
    };

    const showBtn = () => {
      if (!btn) return;
      btn.classList.remove("opacity-0", "pointer-events-none");
    };

    const hideBtn = () => {
      if (!btn) return;
      btn.classList.add("opacity-0", "pointer-events-none");
    };

    const playWithSound = () => {
      try {
        this._pauseAllExcept(v);

        if (isFinite(v.duration) && v.currentTime >= v.duration)
          v.currentTime = 0;

        v.muted = false;
        const p = v.play();
        if (p && typeof p.then === "function") {
          p.catch(() => {
            showBtn();
            setIcon("play");
          });
        }
        hideBtn();
        setIcon("pause");
      } catch (_) {
        showBtn();
        setIcon("play");
      }
    };

    const pauseAndShow = () => {
      v.pause();
      showBtn();
      setIcon("play");
    };

    const toggle = () => {
      if (v.paused) playWithSound();
      else pauseAndShow();
    };

    wrapper.addEventListener("click", (ev) => {
      if (
        ev.target.tagName === "VIDEO" ||
        btn?.contains(ev.target) ||
        wrapper.contains(ev.target)
      ) {
        toggle();
      }
    });

    v.addEventListener("play", () => {
      this._pauseAllExcept(v);
      hideBtn();
      setIcon("pause");
    });

    v.addEventListener("pause", () => {
      showBtn();
      setIcon("play");
    });

    v.addEventListener("ended", () => {
      v.currentTime = 0;
      showBtn();
      setIcon("play");
    });
  }
}

customElements.define("video-reviews-list", VideoReviewsList);
